import { useTranslation } from "react-i18next";
import { BaseItemDialog } from "@/components/shared/BaseItemDialog";
import type { Service } from "@onsemble/shared";

interface ServiceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  mode: "add" | "edit";
  service?: Service;
  orgId: string;
  onServiceAdded?: (serviceId: string, service?: Service) => void;
  onServiceUpdated?: (service: Service) => void;
}

export function ServiceDialog(props: ServiceDialogProps) {
  const { t } = useTranslation();
  return (
    <BaseItemDialog<Service>
      {...props}
      item={props.service}
      apiEndpoint="/api/services"
      queryKey="/api/services"
      itemType="service"
      itemTypeCapitalized={t("components.services.serviceDialog.service")}
      showDescription={true}
      descriptionLabel={t("components.services.serviceDialog.descriptionOptional")}
      descriptionPlaceholder={t("components.services.serviceDialog.detailedDescriptionOfThe")}
      onItemAdded={props.onServiceAdded}
      onItemUpdated={props.onServiceUpdated}
    />
  );
}
